import './userprofile.css';
import React, { useState } from 'react';
import { Tab, Tabs, Container, Row } from 'react-bootstrap';
import TabAnagrafica from '../../components/TabAnagrafica/TabAnagrafica'; 
import TabAzienda from '../../components/TabAzienda/TabAzienda';
import TabParcel from '../../components/TabParcel/TabParcel';
import TabUpload from '../../components/TabUpload/TabUpload';
import { useTranslation } from 'react-i18next';

const UserProfile = () => {
  const [activeTab, setActiveTab] = useState('anagrafica');
  const { t } = useTranslation(['usersetting']);

  return (
    <Container fluid style={{ padding: '0px' }}>
      <Row>
        <Tabs
          id="controlled-tab"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          justify
        >
          <Tab eventKey="anagrafica" title={t("usersetting:tabs.anag")} tabClassName="user-profile-tab">
            <TabAnagrafica />
          </Tab>
          <Tab eventKey="azienda" title={t("usersetting:tabs.farm")} tabClassName="user-profile-tab">
            <TabAzienda />
          </Tab>
          <Tab eventKey="aree" title={t("usersetting:tabs.area")} tabClassName="user-profile-tab">
            <TabParcel />
          </Tab>
          <Tab eventKey="uploads" title={t("usersetting:tabs.upload")} tabClassName="user-profile-tab">
            <TabUpload />
          </Tab>
        </Tabs>
      </Row>
    </Container>
  );
};

export default UserProfile;